module.exports = __webpack_public_path__ + "img/it_it_day-14.e5711f50.svg";